export default "__VITE_ASSET__Czan2ZDD__"